import ToySdk from './ToySdk.class.js'

export default class ToyPCSdk extends ToySdk {
  constructor(conf) {
    super(conf)

    this.hsid = conf.hsid || ''
    this.port = conf.port || 12121
  }
}
